import TextField from '@mui/material/TextField';
import { SxProps, Theme } from '@mui/system';
import { useTranslations } from 'hooks/useTranslations';
import { useFormikInputProps } from 'utils/ui/formik';

type Props = {
  sx?: SxProps<Theme>;
};

export function SupportMessageField(props: Props) {
  const { sx } = props;
  const { value, hasError, helperText, fieldProps } = useFormikInputProps('message');
  const translations = useTranslations();

  return (
    <TextField
      {...fieldProps}
      value={value || ''}
      fullWidth
      label={translations.support.messageHint()}
      helperText={helperText}
      error={hasError}
      sx={sx}
      multiline
      rows={6}
      inputProps={{ maxLength: 1000 }}
    />
  );
}
